export default {
    load: function load(options) {
        return new Promise(function (resolve) {
            var cameras = [{
                    quality: [{
                            name: '0',
                            url: options
                        }]
                }];
            resolve(cameras);
        });
    }
};